const workExperiences = [
    {
        id: 1,
        enterprise: 'Muebles America S.A de C.V',
        url: 'https://www.mueblesamerica.mx/',
        location: 'Guadalajara, Jalisco',
        position: 'Ecommerce backend developer',
        tasks: 'Add features and fix bugs for an online shop',
        tools: [
            'PHPStorm',
            'Git',
            'Git Bash',
            'Oravel VM VirtualBox',
            'Magento',
            'PHP',
            'JavaScript',
            'DBeaver'
        ],
        modality: 'Remote',
        startDate: '15-May-2022',
        endDate: '30-Sep-2023'
    },
    {
        id: 2,
        enterprise: 'AORI',
        url: 'https://www.aori.mx/',
        location: 'Guadalajara, Jalisco',
        position: 'Laravel backend developer',
        tasks: 'Develop API REST services for several customers',
        tools: [
            'VS Code',
            'Laravel',
            'PHP',
            'MySQL',
            'Postman',
            'Git',
            'GitHub'
        ],
        modality: 'Remote',
        startDate: '16-May-2022',
        endDate: '07-Nov-2022'
    },
    {
        id: 3,
        enterprise: 'AppArte',
        url: 'http://www.apparte.com.mx/',
        location: 'Ocosingo, Chiapas',
        position: 'Web Developer',
        tasks: 'Develop a website for school management',
        tools: [
            'VS Code',
            'Laravel',
            'PHP',
            'HTML',
            'JavaScript',
            'jQuery',
            'CSS',
            'MySQL',
            'Git',
            'GitHub'
        ],
        modality: 'Remote',
        startDate: '01-Sep-2021',
        endDate: '14-Feb-2022'
    },
    {
        id: 4,
        enterprise: 'Asciende Computación SA de CV',
        url: 'https://as.com.mx/',
        location: 'Guadalajara, Jalisco',
        position: 'C# Developer',
        tasks: "Develop enterprise's interal custom installer wizard",
        tools: [
            'Visual Studio',
            'C#',
            'SQL Server',
            'Lua scripts',
            'Azure',
            'Slack',
            'Git',
            'GitHub'
        ],
        modality: 'Office',
        startDate: '05-Jan-2021',
        endDate: '15-Apr-2021'
    },
];

export default workExperiences;